import { IChartLegendStyle } from '../models/index.js';
export const chartLegendStyle: IChartLegendStyle = {
	overrides: [
		{
			selector: '[data-selector="base-list-firstContent"]',
			style: {
				flex: {
					_value: 'none',
				},
			},
		},
	],
	children: {
		totalText: {
			font: {
				weight: 'bold',
			},
		},
		totalValue: {
			font: {
				weight: 'bold',
			},
		},
	},
};
